export default class ChildTemplate {
  constructor(parent) {
    this.parent = parent;
  }

  get api() {
    return this.parent.api;
  }

  get permission() {
    return this.parent.permission;
  }

  get setting() {
    return this.parent.setting;
  }

  get emitters() {
    return this.parent.emitters;
  }

  get utils() {
    return this.parent.utils;
  }

  init() {
  }
}
